import React, { useRef } from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
} from '@ui/components';
import { Button } from '@ui/components/ui/button';
import { EllipsisVertical, FilePenLine, Trash, PinIcon, Share2, FolderInput } from 'lucide-react';
import { usePostHogFeatureFlag } from '@ui/hooks';
import { ShareModal } from '@ui/components/organisms/share-modal';
import { DynamicRouteBuilder } from '@ui/constants';
import { INoteBook } from '@cms/services';
interface ContentItemMenuProps {
  notebook: INoteBook;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onEdit: (e: React.MouseEvent<HTMLDivElement>) => void;
  onDelete: (e: React.MouseEvent<HTMLDivElement>) => void;
  onPin: { handlePin: (e: React.MouseEvent<HTMLDivElement>) => void; pinned: boolean };
  onMove: (e: React.MouseEvent<HTMLDivElement>) => void;
  userType?: string;
}

export const ContentItemMenu: React.FC<ContentItemMenuProps> = ({
  isOpen,
  onOpenChange,
  onEdit,
  onDelete,
  onPin,
  onMove,
  userType,
  notebook,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const enableURLShareModal = usePostHogFeatureFlag('enable-url-share-modal');

  return (
    <DropdownMenu open={isOpen} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="rounded"
          data-menu-button="true"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
          <EllipsisVertical />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-40" ref={dropdownRef} hideWhenDetached>
        {userType === 'creator' ? (
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={onEdit} className="space-x-2 cursor-pointer">
              <FilePenLine className="h-4 w-4 mr-2" />
              <span>Edit</span>
            </DropdownMenuItem>

            <DropdownMenuItem onClick={onPin.handlePin} className="space-x-2 cursor-pointer">
              <PinIcon className="h-4 w-4 mr-2" />
              <span>{onPin.pinned ? 'Unpin' : 'Pin'}</span>
            </DropdownMenuItem>

            <DropdownMenuItem onClick={onMove} className="space-x-2 cursor-pointer">
              <FolderInput className="h-4 w-4 mr-2" />
              <span>Move</span>
            </DropdownMenuItem>

            <DropdownMenuItem onClick={onDelete} className="text-red-500 space-x-2 cursor-pointer">
              <Trash className="h-4 w-4 mr-2" />
              <span>Delete</span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        ) : (
          <DropdownMenuGroup>
            {enableURLShareModal && (
              <DropdownMenuItem
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="space-x-2 cursor-pointer">
                <ShareModal
                  url={`${process.env.NEXT_PUBLIC_FAN_WEB_URL}${DynamicRouteBuilder.contentBySlug(
                    notebook.creator_display_name || notebook.creator_id,
                    notebook.slug,
                  )}`}
                  title={notebook.name}>
                  <div className="flex items-center space-x-2 w-full min-w-full">
                    <Share2 className="h-4 w-4" />
                    <span>Share</span>
                  </div>
                </ShareModal>
              </DropdownMenuItem>
            )}
          </DropdownMenuGroup>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
